import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { isLegacyRoute, transformLegacyPath } from './route-transform.utils';

@Injectable({
  providedIn: 'root',
})
export class RouteRedirectGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  // CAPACITOR-Q: a redirecting guard must return a UrlTree, never call
  // router.navigate() and return false. The old form started a SECOND
  // navigation from inside the guard of a navigation Angular was still
  // resolving, so two activations raced on the same primary outlet and threw
  // « Cannot activate an already activated outlet ». Returning the UrlTree
  // lets the router cancel the current navigation and run the redirect as one
  // navigation: one at a time.
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const path = route.routeConfig?.path || '';
    const params = route.params;
    const fullPath = '/' + (params['id'] ? `${path.replace(':id', params['id'])}` : path);

    if (isLegacyRoute(fullPath)) {
      const redirectPath = transformLegacyPath(fullPath);
      return this.router.createUrlTree([redirectPath]);
    }

    return true;
  }
}
